import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox
} from "@mui/material";
import { Card, Alert } from "reactstrap";
import Layout from "../../components/Wrappers/Layout";
import BackButton from "../../components/BackButton/BackButton";
import { useSelector, useDispatch } from "react-redux";

import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
// import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { makeStyles } from "@mui/styles";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import { AiOutlineSearch } from "react-icons/ai";
import { getKycConfigurationList } from "../../redux/actions/getKycConfigurationListAction";
import { deleteKycConfigurationRecord } from "../../redux/actions/deleteKycConfigurationRecordAction";
import FileBase64 from "../../components/Upload/UploadFile";
import SaveIcon from "@mui/icons-material/Save";
import { getKycConfigurationDetails } from "../../redux/actions/getKycConfigurationDetailsAction";
import { addUpdateKycConf } from "../../redux/actions/addUpdateKycConfAction";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const KycConfigration = () => {
	const [isLoading, setIsLoading] = useState(false);
	const classes = useStyles();
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);
	const [role, setRole] = useState("Select Role");
	const [entity, setEntity] = useState("Select Entity Type");
	const [kycLevel, setKycLevel] = useState("Select KYC Level");
	
	const [notificationOpen, setNotificationOpen] = useState(false);
	const dispatch = useDispatch();

	const [getKycConfigurationStatus, setGetKycConfigurationStatus] =
		useState(false);
	const [getKycConfigurationResArray, setGetKycConfigurationResArray] =
		useState("");

	const [getKycConfDetailsStatus, setGetKycConfDetailsStatus] = useState(false);
	const [getKycConfDetailsResArray, setGetKycConfDetailsResArray] =
		useState("");

	const [addKycConfDetailsStatus, setAddKycConfDetailsStatus] = useState(false);
	const [addKycConfDetailsResArray, setAddKycConfDetailsResArray] =
		useState([]);

	const [open, setOpen] = useState(false);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const AddUpdateKycConfRes = useSelector(
		({ addUpdateKycConf }) => addUpdateKycConf
	);

	const getKycConfDetailsRes = useSelector(
		({ getKycConfigurationDetails }) => getKycConfigurationDetails
	);

	const getWalletRolesRes = useSelector(
		({ walletAcRequired }) => walletAcRequired
	);

	const getKycConfigurationListRes = useSelector(
		({ getKycConfigurationList }) => getKycConfigurationList
	);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
		
	};

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getKycConfDetailsReq();
		}
	}, [regenerateTokenRes.data.status, kycLevel]);

	const getKycConfDetailsReq = () => {
		setGetKycConfDetailsStatus(true);
		setIsLoading(true);
		let req = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				kycLevel: kycLevel
			}
		};
		dispatch(getKycConfigurationDetails(req, authToken));
	};

	const getKycConfDetailsFunc = () => {
		if (getKycConfDetailsStatus) {
			if (getKycConfDetailsRes.data.status == "success") {
				setGetKycConfDetailsResArray(getKycConfDetailsRes.data.moduleList);
				setIsLoading(false);
			}
			if (getKycConfDetailsRes.data.status == "failed") {
				setGetKycConfDetailsResArray(getKycConfDetailsRes.data);
				setIsLoading(false);
				if (
					getKycConfDetailsRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getKycConfDetailsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getKycConfDetailsRes.data.status == "Failed") {
				setGetKycConfDetailsResArray(getKycConfDetailsRes.data);
				setIsLoading(false);
				if (
					getKycConfDetailsRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getKycConfDetailsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getKycConfDetailsRes.data.status === 'NOT FOUND') {
				setIsLoading(false)
				NotificationPopups(
					"error",
					"Failed",
					getKycConfDetailsRes.data.status);
			}
		}
	};

	// console.log(getKycConfDetailsResArray, "getKycConfDetailsResArray////////////////////")
	// console.log(AddUpdateKycConfRes, "AddUpdateKycConfRes////////////////////");

	useEffect(() => {
		getKycConfDetailsFunc();
	}, [getKycConfDetailsRes.data.status]);

	const [blockIDS, setBlockIDS] = useState({
		blockId: []
	});

	const onCheck = (id, e) => {
		const { value, checked } = e.target;
		const { blockId } = blockIDS;
		if (checked) {
			setBlockIDS({
				blockId: [...blockId, id]
			});
		} else {
			setBlockIDS({
				blockId: blockId.filter((e) => e !== id)
			});
		}
	};

	useEffect(() => {
		console.log(blockIDS.blockId, "////////////////////");
	}, [blockIDS]);
     
	const isSaveButtonDisabled = !role || !entity || !kycLevel || blockIDS.blockId.length === 0;


	const addKycConf = () => {
		if (!role || !entity || !kycLevel || blockIDS.blockId.length === 0) {
			setNotificationOpen(true);
			setAddKycConfDetailsResArray({
				status: 'failed',
				description: 'Please fill all required fields.'
			});
			return;
		}
		setAddKycConfDetailsStatus(true);
		let req = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				role: role,
				entityType: entity,
				kycLevel: kycLevel,
				kycDocIds: blockIDS.blockId
			}
		};
		dispatch(addUpdateKycConf(req, authToken));
	};
	
	
	// const addKycConf = () => {
	// 	setAddKycConfDetailsStatus(true);
	// 	let req = {
	// 		loginDetails: {
	// 			walletOwnerId: regenerateTokenRes.data.partnerId || ""
	// 		},
	// 		actionCustomerMasterRequestVO: {
	// 			role: role,
	// 			entityType: entity,
	// 			kycLevel: kycLevel,
	// 			kycDocIds: blockIDS.blockId
	// 		}
	// 	};
	// 	dispatch(addUpdateKycConf(req, authToken));
	// };
	



	const addKycConfDetailsFunc = () => {
		if (addKycConfDetailsStatus) {
			if (AddUpdateKycConfRes.data.status == "success") {
				setNotificationOpen(true);
				setAddKycConfDetailsResArray(AddUpdateKycConfRes.data);
			}
			if (AddUpdateKycConfRes.data.status == "failed") {
				setNotificationOpen(true);
				setAddKycConfDetailsResArray(AddUpdateKycConfRes.data);
				if (
					AddUpdateKycConfRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					AddUpdateKycConfRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (AddUpdateKycConfRes.data.status == "Failed") {
				setNotificationOpen(true);
				setAddKycConfDetailsResArray(AddUpdateKycConfRes.data);
				if (
					AddUpdateKycConfRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					AddUpdateKycConfRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		addKycConfDetailsFunc();
	}, [AddUpdateKycConfRes.data.status]);
	const handleChange = ({ target: { name, value } }) => {
		if (name === "role") {
			setRole(value === "Select Role" ? "" : value);
		}
	
		if (name === "entity") {
			setEntity(value === "Select Entity Type" ? "" : value);
		}
	
		if (name === "kycLevel") {
			setKycLevel(value === "Select KYC Level" ? "" : value);
		}
	};
	


	const handleClose = () => {
		setOpen(false);
		setRole("");
		setEntity("");
	};

	const [uploadFile, setUploadFile] = useState("");

	const [UploadFileName, setUploadFileName] = useState("");

	const handleAttachmentsDoc = (e, uploadFile) => {
		if (uploadFile == "uploadFile") {
			setUploadFile(e.base64);
			setUploadFileName(e.name);
		}
	};

	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								select
								required
								autoFocus
								margin="dense"
								id="name"
								label="Role"
								fullWidth
								variant="standard"
								type="text"
								name="role"
								defaultValue={"Select Role" || role}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Select Role" selected="Select Role">
									Select Role
								</MenuItem>
								{getWalletRolesRes.success &&
									getWalletRolesRes.data.rolesList.map((x) => (
										<MenuItem value={x}>{x}</MenuItem>
									))}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								select
								required
								autoFocus
								margin="dense"
								id="name"
								label="Entity Type"
								fullWidth
								variant="standard"
								type="text"
								name="entity"
								defaultValue={"Select Entity Type" || entity}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem
									value="Select Entity Type"
									selected="Select Entity Type"
								>
									Select Entity Type
								</MenuItem>
								<MenuItem value="Individual">Individual</MenuItem>
								<MenuItem value="Legal">Legal</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								select
								required
								autoFocus
								margin="dense"
								id="name"
								label="KYC Level"
								fullWidth
								variant="standard"
								type="text"
								name="kycLevel"
								defaultValue={"Select KYC Level" || kycLevel}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Select KYC Level" selected="Select KYC Level">
									Select KYC Level
								</MenuItem>
								<MenuItem value="Basic">Basic</MenuItem>
								<MenuItem value="Standard">Standard</MenuItem>
								<MenuItem value="Premium">Premium</MenuItem>
								<MenuItem value="Supreme">Supreme</MenuItem>
								<MenuItem value="COMPANYDOCS">Company</MenuItem>
							</TextField>
						</Grid>

						{isLoading ? (
							<div style={{ margin: "auto" }}>
								<LoadingSpinner />
							</div>
						) : (
							getKycConfDetailsRes.data.moduleList &&
							[].concat(getKycConfDetailsRes.data.moduleList).map((x) => (
								<>
									<Grid
										item
										xs={12}
										lg={12}
										md={12}
										sm={12}
										style={{
											marginTop: "36px",
											padding: "10px",
											color: "#fff"
										}}
										className="tableHeaderColor"
									>
										<h6
											align="left"
											style={{
												margin: "0"
											}}
										>
											{x.moduleName}
										</h6>
									</Grid>
									<Grid item xs={12} md={2} lg={2}></Grid>
									<Grid item xs={12} md={8} lg={8}>
										{[].concat(x.subModuleList).map((y) => (
											<div style={{ marginTop: "1.5rem" }}>
												<Checkbox
													color="primary"
													onChange={(e) => onCheck(y.split("-")[0], e)}
												/>
												<b className="themeText">{y.split("-")[1]}</b>
											</div>
										))}
									</Grid>
								</>
							))
						)}
					</Grid>
					<div
						style={{
							margin: "20px",
							textAlign: "center"
						}}
					>
						<CustomButton
							style={{
								padding: "8px"
							}}
							onClick={addKycConf}
						    disabled={isSaveButtonDisabled}
						>
							Save
						</CustomButton>
					</div>
				</Card>
			</Layout>

			{AddUpdateKycConfRes.data.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
            <DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
			
			>
                <img
                    src={
                        addKycConfDetailsResArray.status === 'success'
                            ? success
                            : failed
                    }
                    alt=""
                    width="100px"
                    className="my-2"
                />
            </DialogContent>
            <DialogContent>
                <h4 style={{ margin: '0', textAlign: 'center', fontSize: '15px' }}>
                    {addKycConfDetailsResArray.status === 'success'
                        ? 'success'
                        : 'failed'}
                </h4>
            </DialogContent>
            <DialogActions style={{ justifyContent: 'center' }}>
                <CustomButton style={{ padding: '8px' }} onClick={handleNoticationClose}>
                    Ok
                </CustomButton>
            </DialogActions>
        </Dialog>
    </div>)
	};

{AddUpdateKycConfRes.data.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{AddUpdateKycConfRes.data.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{/* {AddUpdateKycConfRes.data.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center lightThemeBackground">
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{AddUpdateKycConfRes.data.status}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{AddUpdateKycConfRes.data.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center lightThemeBackground">
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{AddUpdateKycConfRes.data.status}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)} */}
		</>
	);
};

export default KycConfigration;
